import type { MuiPage } from '@mui/internal-core-docs/MuiPage';

const dataGridApiPages: MuiPage[] = [
  {
    pathname: '/x/api/data-grid/ai-assistant-panel-trigger',
    title: 'AiAssistantPanelTrigger',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/charts-panel-trigger',
    title: 'ChartsPanelTrigger',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/columns-panel-trigger',
    title: 'ColumnsPanelTrigger',
  },
  {
    pathname: '/x/api/data-grid/data-grid',
    title: 'DataGrid',
  },
  {
    pathname: '/x/api/data-grid/data-grid-premium',
    title: 'DataGridPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/data-grid-pro',
    title: 'DataGridPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/data-grid/export-csv',
    title: 'ExportCsv',
  },
  {
    pathname: '/x/api/data-grid/export-excel',
    title: 'ExportExcel',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/export-print',
    title: 'ExportPrint',
  },
  {
    pathname: '/x/api/data-grid/filter-panel-trigger',
    title: 'FilterPanelTrigger',
  },
  {
    pathname: '/x/api/data-grid/grid-charts-panel',
    title: 'GridChartsPanel',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/grid-charts-renderer-proxy',
    title: 'GridChartsRendererProxy',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/grid-filter-form',
    title: 'GridFilterForm',
  },
  {
    pathname: '/x/api/data-grid/grid-filter-panel',
    title: 'GridFilterPanel',
  },
  {
    pathname: '/x/api/data-grid/grid-toolbar-quick-filter',
    title: 'GridToolbarQuickFilter',
  },
  {
    pathname: '/x/api/data-grid/pivot-panel-trigger',
    title: 'PivotPanelTrigger',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/prompt-field',
    title: 'PromptField',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/prompt-field-control',
    title: 'PromptFieldControl',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/prompt-field-record',
    title: 'PromptFieldRecord',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/prompt-field-send',
    title: 'PromptFieldSend',
    plan: 'premium',
  },
  {
    pathname: '/x/api/data-grid/quick-filter',
    title: 'QuickFilter',
  },
  {
    pathname: '/x/api/data-grid/quick-filter-clear',
    title: 'QuickFilterClear',
  },
  {
    pathname: '/x/api/data-grid/quick-filter-control',
    title: 'QuickFilterControl',
  },
  {
    pathname: '/x/api/data-grid/quick-filter-trigger',
    title: 'QuickFilterTrigger',
  },
  {
    pathname: '/x/api/data-grid/toolbar',
    title: 'Toolbar',
  },
  {
    pathname: '/x/api/data-grid/toolbar-button',
    title: 'ToolbarButton',
  },
];
export default dataGridApiPages;
